import * as yup from "yup";

const currentYear = new Date().getFullYear();

export const UniversityFormValidation = yup
  .object()
  .shape({
    description: yup.string().required("Descrição é obrigatória"),
    abbreviation: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    province: yup.string().required("Provincia é obrigatória"),
    district: yup.string().nullable().optional(),
    nuit: yup
      .string()
     .nullable().optional().matches(
        /^[1-9]\d{8}$/,
        "NUIT deve conter exatamente 9 dígitos numéricos"
      ),
    code: yup.string().nullable().optional(),
    dirigentFullname: yup.string().nullable().optional(),
    responsableFullname: yup.string().nullable().optional(),
    yearCreated: yup
      .number().nullable().optional()
      .typeError("Ano de criação deve ser numérico")
      .integer("Ano inválido")
      .min(1900, "Ano deve ser maior ou igual a 1900")
      .max(currentYear, `Ano não pode ser maior que ${currentYear}`)
      ,

    dateCreated: yup.string().nullable().optional().typeError("Data de criação inválida"),

    type: yup.string().nullable().optional(),

    status: yup.boolean(),

    website: yup.string().nullable().optional().url("URL do website inválida"),

    email: yup.string().nullable().optional().email("Email da instituição inválido"),

    dirigentEmail: yup.string().nullable().optional().email("Email do dirigente inválido"),

    dirigentPhoneNumber: yup
      .string().nullable().optional()
      .matches(/^(82|83|84|85|86|87)\d{7}$/, "Número de telemóvel inválido")
      ,

    responsableEmail: yup
      .string().nullable().optional()
      .email("Email do responsável inválido")
      ,

    responsablePhoneNumber: yup
      .string().nullable().optional()
      .matches(/^(82|83|84|85|86|87)\d{7}$/, "Número de telemóvel inválido")
      ,
  })
  .test(
    "year-date-match",
    "Ano de criação deve corresponder ao ano da data de criação",
    function (values) {
      const { yearCreated, dateCreated } = values as any;

      if (!yearCreated || !dateCreated) return true;

      const dateYear = new Date(dateCreated).getFullYear();
      return dateYear === yearCreated;
    }
  );
